import "./CtaBand.scss"

import React from "react"
import { i18n } from "@lingui/core"

// Tùy biến KHCN: dải kêu gọi cuối trang theo bản thiết kế — phong cảnh Hà Tĩnh cách điệu ban ngày
// (mây trôi, cầu, thành phố, turbine gió quay) với thông điệp và nút "Tham gia ngay".

const Turbine = ({ x, y, scale = 1 }: { x: number; y: number; scale?: number }) => (
  <g transform={`translate(${x} ${y}) scale(${scale})`}>
    <path d="M-3 0h6l4 120h-14z" fill="#ffffff" opacity="0.95" />
    <g className="kh-cta__rotor" stroke="#ffffff" strokeWidth="5" strokeLinecap="round" fill="none">
      <path d="M0 0v-52M0 0l45 26M0 0l-45 26" />
    </g>
    <circle r="5" fill="#ffffff" />
  </g>
)

export const CtaBand = ({ onAction }: { onAction: () => void }) => (
  <section className="kh-cta">
    <svg className="kh-cta__scene" viewBox="0 0 1600 360" preserveAspectRatio="xMidYMid slice" aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id="khCtaSky" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#5aa7ff" />
          <stop offset="0.7" stopColor="#bfe3ff" />
          <stop offset="1" stopColor="#e6f3ff" />
        </linearGradient>
      </defs>
      <rect width="1600" height="360" fill="url(#khCtaSky)" />
      <g fill="#ffffff" opacity="0.7">
        <g className="kh-cta__cloud kh-cta__cloud--1">
          <ellipse cx="300" cy="80" rx="110" ry="22" />
          <ellipse cx="350" cy="66" rx="60" ry="26" />
        </g>
        <g className="kh-cta__cloud kh-cta__cloud--2">
          <ellipse cx="1000" cy="60" rx="130" ry="20" />
          <ellipse cx="1060" cy="48" rx="70" ry="24" />
        </g>
      </g>
      {/* đồi xa */}
      <path d="M0 250L180 190L340 230L520 170L720 240L900 200L1080 250L1600 220V360H0Z" fill="#2f8bff" opacity="0.45" />
      {/* mặt nước */}
      <rect x="0" y="270" width="1600" height="90" fill="#1d6fe8" opacity="0.55" />
      {/* cầu */}
      <g stroke="#0a2e7a" strokeLinecap="round" opacity="0.85">
        <line x1="620" y1="270" x2="1180" y2="270" strokeWidth="8" />
        <line x1="800" y1="270" x2="800" y2="150" strokeWidth="10" />
        <line x1="1000" y1="270" x2="1000" y2="150" strokeWidth="10" />
        {[-150, -100, -50, 50, 100, 150].map((dx) => (
          <React.Fragment key={dx}>
            <line x1="800" y1="156" x2={800 + dx} y2="266" strokeWidth="1.6" />
            <line x1="1000" y1="156" x2={1000 + dx} y2="266" strokeWidth="1.6" />
          </React.Fragment>
        ))}
      </g>
      {/* thành phố */}
      <g fill="#0e4cb5" opacity="0.9">
        {[
          [1200, 200, 44, 70],
          [1250, 170, 54, 100],
          [1312, 190, 40, 80],
          [1360, 150, 60, 120],
          [1430, 185, 46, 85],
          [1484, 160, 56, 110],
        ].map(([x, y, w, h]) => (
          <rect key={x} x={x} y={y} width={w} height={h} rx="3" />
        ))}
      </g>
      {/* cổng thành / di tích */}
      <g fill="#0a2e7a" opacity="0.9" transform="translate(1120 210)">
        <rect x="-40" y="-8" width="80" height="10" rx="2" />
        <rect x="-32" y="2" width="12" height="58" />
        <rect x="20" y="2" width="12" height="58" />
        <path d="M-20 60a20 22 0 0 1 40 0z" fill="#2f8bff" />
      </g>
      <Turbine x={200} y={230} scale={0.8} />
      <Turbine x={330} y={215} />
      <Turbine x={470} y={235} scale={0.7} />
    </svg>
    <div className="kh-cta__wash" aria-hidden="true" />
    <div className="kh-cta__content">
      <p className="kh-cta__line1">{i18n._({ id: "khcn.cta.line1", message: "Together with the community, let's build" })}</p>
      <p className="kh-cta__line2">{i18n._({ id: "khcn.cta.line2", message: "a smart, sustainable, prosperous Hà Tĩnh" })}</p>
    </div>
    <button type="button" className="kh-cta__btn" onClick={onAction}>
      {i18n._({ id: "khcn.cta.button", message: "Join now" })}
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M5 12h14M13 6l6 6-6 6" />
      </svg>
    </button>
  </section>
)
